// =============================================================================
// MHV Live Slideshow — Product image slideshow display + navigation
// Extracted from sections/live.liquid (Script Blocks 4, 5, 6)
//
// Uses globals from live-main.js: isSlideshowVisible, safeSetText
// Uses globals from live-page.js: showSlideshow, clearSlideshow, toggleSlideshowVisibility
// Shares state via window: currentImages, currentSlideIndex, slideshowInterval, etc.
// =============================================================================

(function() {
  'use strict';

  // Delegated-listener guard: register the document-level click handler once.
  var clickDelegationBound = false;
  function bindClickDelegation() {
    if (clickDelegationBound) return;
    clickDelegationBound = true;
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-act]');
      if (!t) return;
      var act = t.getAttribute('data-act');
      if (act === 'go-to-slide') {
        goToSlide(Number(t.getAttribute('data-p0')));
      }
    });
  }

  // Slideshow state (shared via window — set up by live-main.js)
  var currentImages = window.currentImages || [];
  var currentSlideIndex = window.currentSlideIndex || 0;
  var slideshowInterval = window.slideshowInterval || null;
  var hasCompletedCycle = window.hasCompletedCycle || false;
  var isPhotoGallery = window.isPhotoGallery || false;

  // =================================
  // Initialize slideshow
  // =================================
  function initializeSlideshow() {
    bindClickDelegation();
    var slideshowContainer = document.getElementById('product-slideshow-container');
    if (!slideshowContainer) return;

    // Check if we already have images from chat-slides
    if (window.mhvSlidesImages && window.mhvSlidesImages.length > 0) {
      loadSlideshowImages(window.mhvSlidesImages);
    }

    // Listen for new image events
    window.addEventListener('mhv:slides:images', function(e) {
      var images = (e.detail && e.detail.images) || [];
      loadSlideshowImages(images);
    });
  }
  window.initializeSlideshow = initializeSlideshow;

  // =================================
  // Load images into slideshow
  // =================================
  function loadSlideshowImages(images) {
    if (!images || images.length === 0) {
      showSlideshowPlaceholder();
      return;
    }

    currentImages = images;
    window.currentImages = images;
    currentSlideIndex = 0;
    window.currentSlideIndex = 0;

    // Check if this is a photo gallery
    var product = window.product || {};
    var productHandle = product.handle || product.product_handle || '';
    isPhotoGallery = productHandle.includes('photo-gallery') || (productHandle.length === 8 && productHandle.includes('20'));
    window.isPhotoGallery = isPhotoGallery;

    hasCompletedCycle = false;
    window.hasCompletedCycle = false;

    var slideshow = document.getElementById('product-slideshow');
    if (slideshow) {
      var html = '';
      for (var i = 0; i < images.length; i++) {
        var alt = images[i].alt || ('Image ' + (i + 1));
        html += '<img src="' + images[i].url + '" alt="' + alt + '" class="slide" data-index="' + i + '">';
      }
      slideshow.innerHTML = html;
    }

    setupSlideshowControls(images.length);
    showSlide(0);
    // Don't start local autoplay — slides are synced from the host owner via socket

    var placeholder = document.getElementById('slideshow-placeholder');
    if (placeholder) placeholder.style.display = 'none';

    if (window.isSlideshowVisible) {
      var videoContainer = document.getElementById('whep-player-container');
      var slideshowContainer = document.getElementById('product-slideshow-container');
      // Slideshow on-stage → hide the video player (inverse of slideshow visibility).
      if (videoContainer) videoContainer.style.display = 'none';
      // Don't force the slideshow visible while a multi-lot grid is on-air — the
      // grid container would be covered. live-page.js clears the grid first when
      // a real single-lot update supersedes it.
      if (slideshowContainer && !window.currentGridLots) slideshowContainer.style.display = 'flex';
    }
  }
  window.loadSlideshowImages = loadSlideshowImages;

  // =================================
  // Slideshow controls setup
  // =================================
  function setupSlideshowControls(imageCount) {
    var controls = document.getElementById('slideshow-controls');
    var dots = document.getElementById('slideshow-dots');
    if (!controls || !dots) return;

    if (imageCount > 1) {
      controls.style.display = 'flex';
      var html = '';
      for (var i = 0; i < currentImages.length; i++) {
        html += '<div class="slideshow-dot" data-act="go-to-slide" data-p0="' + i + '" data-index="' + i + '"></div>';
      }
      dots.innerHTML = html;
      updateArrowStates();
    } else {
      controls.style.display = 'none';
    }
  }

  // =================================
  // Slide navigation
  // =================================
  function showSlide(index) {
    var slides = document.querySelectorAll('.product-slideshow .slide');
    var dots = document.querySelectorAll('.slideshow-dot');
    if (slides.length === 0) return;

    for (var i = 0; i < slides.length; i++) slides[i].classList.remove('active');
    if (slides[index]) slides[index].classList.add('active');

    for (var j = 0; j < dots.length; j++) {
      if (j === index) dots[j].classList.add('active');
      else dots[j].classList.remove('active');
    }

    currentSlideIndex = index;
    window.currentSlideIndex = index;
    updateArrowStates();
  }
  window.showSlide = showSlide;

  function updateArrowStates() {
    var prevBtn = document.getElementById('slideshow-prev');
    var nextBtn = document.getElementById('slideshow-next');
    if (prevBtn) prevBtn.disabled = currentSlideIndex === 0;
    if (nextBtn) nextBtn.disabled = currentSlideIndex === currentImages.length - 1;
  }

  function nextSlide() {
    if (currentSlideIndex < currentImages.length - 1) {
      showSlide(currentSlideIndex + 1);
    } else {
      if (isPhotoGallery) {
        showSlide(0);
      } else {
        if (!hasCompletedCycle) {
          hasCompletedCycle = true;
          window.hasCompletedCycle = true;
          showSlide(0);
          stopSlideshowAutoplay();
        } else {
          showSlide(0);
        }
      }
    }
  }
  window.nextSlide = nextSlide;

  function previousSlide() {
    if (currentSlideIndex > 0) {
      showSlide(currentSlideIndex - 1);
    }
  }
  window.previousSlide = previousSlide;

  function goToSlide(index) {
    if (index >= 0 && index < currentImages.length) {
      showSlide(index);
    }
  }
  window.goToSlide = goToSlide;

  // =================================
  // Autoplay
  // =================================
  function startSlideshowAutoplay() {
    if (slideshowInterval) clearInterval(slideshowInterval);

    if (currentImages.length > 1) {
      slideshowInterval = setInterval(function() {
        if (currentSlideIndex < currentImages.length - 1) {
          nextSlide();
        } else {
          showSlide(0);
        }
      }, 3000);
      window.slideshowInterval = slideshowInterval;
    }
  }
  window.startSlideshowAutoplay = startSlideshowAutoplay;

  function stopSlideshowAutoplay() {
    if (slideshowInterval) {
      clearInterval(slideshowInterval);
      slideshowInterval = null;
      window.slideshowInterval = null;
    }
  }
  window.stopSlideshowAutoplay = stopSlideshowAutoplay;

  // Live slideshow playback controls removed — slideshow synced from host owner

  // =================================
  // Placeholder
  // =================================
  function showSlideshowPlaceholder() {
    var slideshow = document.getElementById('product-slideshow');
    if (slideshow) {
      slideshow.innerHTML = '<div class="slideshow-placeholder"><div class="placeholder-content"><h3>No Images</h3><p>This product has no images available</p></div></div>';
    }

    if (!window.isSlideshowVisible) return;
    // Suppress the placeholder if a multi-lot grid is currently on-air
    if (window.currentGridLots) return;

    var slideshowContainer = document.getElementById('product-slideshow-container');
    var placeholder = document.getElementById('slideshow-placeholder');
    var videoContainer = document.getElementById('whep-player-container');
    if (videoContainer) videoContainer.style.display = 'none';
    if (slideshowContainer) slideshowContainer.style.display = 'flex';
    if (placeholder) placeholder.style.display = 'block';

    var controls = document.getElementById('slideshow-controls');
    if (controls) controls.style.display = 'none';

    stopSlideshowAutoplay();
  }
  window.showSlideshowPlaceholder = showSlideshowPlaceholder;

  // =================================
  // Keyboard navigation
  // =================================
  document.addEventListener('keydown', function(e) {
    if (currentImages.length === 0) return;
    if (e.key === 'ArrowLeft') { e.preventDefault(); previousSlide(); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); nextSlide(); }
  });

})();
